<template>
<div class="footer-sub">
  <div class="footer container">
    <img src="../../assets/img/arko-mebel-logo.png" alt="" class="nav__head-logo">
    <p class="footer__text">&copy; ArkoMebel company</p>
    <div class="footer__info">
      <a href="https://t.me/diyorbek_joraqulov" target="_blank" class="footer__info-link">
        <img src="../../assets/img/telegram.webp" class="footer__info-link__telegram" alt="">
      </a>
      <a href="https://github.com/diyorbekjoraqulov8" target="_blank" class="footer__info-link">
        <img src="../../assets/img/Github.svg" class="footer__info-link__github" alt="">
      </a>
      <a href="#!" class="footer__info-link">
        <img src="../../assets/img/headhunter.png" target="_blank" class="footer__info-link__hh" alt="">
      </a>
    </div>
  </div>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>